import React from "react";
import { Textarea } from "../../../sudokit/components/Textarea";
import { SudoButton } from "../../../sudokit/components/SudoButton";
import { WordCountHint } from "./WordCountHint";

export const ExampleInputSection = ({
  testValue,
  onTestValueChange,
  onInsertExample,
  highlightedTextLimits,
}) => {
  return (
    <div className="test-example-field">
      <div className="test-example-header">
        <span id="plugin-tester-selected-text-label">Paste or type a text example to adjust with your plugin.</span>
        {!testValue.trim().length && (
          <SudoButton
            type="button"
            variant="tertiaryGrey"
            size="xsmall"
            className="test-example-button"
            onClick={onInsertExample}
          >
            Insert an example
          </SudoButton>
        )}
      </div>
      <Textarea
        id="plugin-tester-selected-text-input"
        value={testValue}
        placeholder="This text represents the user's selected text."
        aria-label="Selected text test input"
        aria-describedby="plugin-tester-selected-text-label"
        onChange={(e) => onTestValueChange(e.target.value)}
        lineHeight={1.5}
        minRows={10}
        className="test-message"
      />
      <WordCountHint text={testValue} limits={highlightedTextLimits} />
    </div>
  );
};
